<template>
    <div>
        <div id="PermisosDeUsuarios_div" class="w-100 px-5 py-4">
            <div id="TituloPermisosDeUsuarios_div">
                <h1>AJUSTES DEL USUARIOS</h1>
                <h3 class="subtitle-text">Encargado de modificar la información de los usuarios</h3>
            </div>
            <div class="d-flex row">
                <div v-if="usuario.UsuarioId == null" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 padding-div-low">
                    <div class="card-header">
                       <h2>Búsqueda</h2>
                    </div>
                    <div class="area card-body">                        
                        <h6 class="text-form">Se puede buscar por medio del login del usuario o por medio de la combinacion del nombre del usuario.<br />La busqueda prioritizara la busqueda por medio de login del usuario</h6>
                        <hr />
                        <h6 class="text-form">Login del usuario</h6>
                        <input type="text" class="form-control" v-model="login" placeholder="ejemplo@pjags.gob.mx" />
                        <hr />
                        <div class="form-group">
                            <h6 class="text-form">Nombre(s)</h6>
                            <input type="text" class="form-control" v-model="nombres" placeholder="Nombre o nombres del usuario" />
                        </div>
                        <div class="form-group">
                            <h6 class="text-form">Primer apellido</h6>
                            <input type="text" class="form-control" v-model="primerApellido" placeholder="Primer apellido del usuario" />
                        </div>
                        <div class="form-group">
                            <h6 class="text-form">Segundo apellido</h6>
                            <input type="text" class="form-control" v-model="segundoApellido" placeholder="Segundo apellido del usuario" />
                        </div>
                        <br />
                        <div id="BuscarUsuario_div" class="text-right">
                            <button class="btn btn-primary overwrapDeBotones" id="buscarUsuario" v-on:click="BuscarUsuarios()">Buscar usuario</button>
                        </div>
                    </div>
                </div>
                <div v-if="usuario.UsuarioId != null && usuario.Login != null" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 padding-div-low">
                    <div class="card-header">
                       <h2>Edición</h2>
                    </div>
                    <div class="area card-body">                        
                        <h6 class="text-form">Actualmente se encuentra en la ventana de edición del usuario. Una vez finalice la edición, puede dar clic sobre el boton "Guardar usuario". Si no desea guardar los cambios, de clic sobre el boton "Cancelar y cerrar"</h6>
                        <hr />
                        <h6 class="text-form">Email: {{usuario.Login}}</h6>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 padding-div-low">
                    <div v-if="usuario.UsuarioId == null" class="card-header">
                       <h3 >Usuarios</h3>
                    </div>
                    <div class="area card-body">                        
                        <h6 v-if="usuario.UsuarioId == null" class="text-form">Aqui se muestra el listado de usuarios que se obtuvo en base a sus filtros de busqueda.</h6>
                        <h6 v-if="usuario.UsuarioId == null" class="text-form">Seleccione una de las filas para poder asignarle los permisos al usuario.</h6>
                        <hr v-if="usuario.UsuarioId == null" />
                        <div v-if="usuario.UsuarioId == null" class="col-12 table-responsive">
                            <table class="table table-striped table-light table-hover table-bordered" id="tablaDeUsuarios_table">
                                <thead class="table-header-global text-center">
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre completo</th>
                                        <th>Login</th>
                                        <th>Activo</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody class="text-justify">
                                    <tr v-if="respuestaDeListadoDeUsuarios.length <= 0" class="text-center" >
                                        <td colspan="5">No existen registros con esas condiciones de busqueda</td>
                                    </tr>
                                    <tr v-else v-for="usuarioDelListado in respuestaDeListadoDeUsuarios" :key="usuarioDelListado.IdUsuario" style="cursor: pointer">
                                        <td v-on:click="AsignaElUsuarioYLogin(usuarioDelListado.IdUsuario, usuarioDelListado.Email)" class="text-center">{{usuarioDelListado.IdUsuario}}</td>
                                        <td v-on:click="AsignaElUsuarioYLogin(usuarioDelListado.IdUsuario, usuarioDelListado.Email)">{{usuarioDelListado.Nombre}}{{(usuarioDelListado.ApellidoPaterno != "" && usuarioDelListado.ApellidoPaterno != null ? " " + usuarioDelListado.ApellidoPaterno : "")}}{{(usuarioDelListado.ApellidoMaterno != "" && usuarioDelListado.ApellidoMaterno != null ? " " + usuarioDelListado.ApellidoMaterno : "")}}</td>
                                        <td v-on:click="AsignaElUsuarioYLogin(usuarioDelListado.IdUsuario, usuarioDelListado.Email)">{{usuarioDelListado.Email}}</td>
                                        <td v-on:click="AsignaElUsuarioYLogin(usuarioDelListado.IdUsuario, usuarioDelListado.Email)" class="text-center">{{(usuarioDelListado.UsuarioActivo == true ? 'Si' : 'No')}}</td>
                                        <td class="text-center">
                                            <a v-on:click="ModificaElEstatusDelUsuario(false, usuarioDelListado.IdUsuario)" v-if="usuarioDelListado.UsuarioActivo == true" title="Desactiva al usuario"><i class="fas fa-ban"></i></a>
                                            <a v-on:click="ModificaElEstatusDelUsuario(true, usuarioDelListado.IdUsuario)" v-else-if="usuarioDelListado.UsuarioActivo == false" title="Activa al usuario"><i class="far fa-check-circle"></i></a>
                                            <p v-else title="Desactiva al usuario">Mal registrado</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Usuario v-if="usuario.UsuarioId != null" :usuarioId="usuario.UsuarioId" :segundaParteDelAPI="segundaParteDelAPI" :funcionId="3" v-on:ejecutaLaFuncionalidadDeCancelado="CancelaLaEdicionDelUsuario" v-on:ejecutaLaFuncionalidadDeGuardado="GuardaElUsuario"></Usuario>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'

import Usuario from '@/components/SICUS/Comun/Usuario.vue'

export default {
    data() {
        return {
            enumeraciones,
            login: "",
            nombres: "",
            primerApellido: "",
            segundoApellido: "",
            respuestaDeListadoDeUsuarios: [],
            usuario: {
                UsuarioId: null, 
                Login: null
            }
        }
    },
    components: {
        Usuario
    },
    computed: {
        segundaParteDelAPI() {
            return api.SICUS.sistema.usuarios.ajustesDeUsuarios.ObtenUsuario
        }
    },
    methods: {
        LimpiaParaNuevaBusqueda: function() {
            this.respuestaDeListadoDeUsuarios = [];

            this.LimpiaParaNuevoUsuario();
        },
        LimpiaParaNuevoUsuario: function() {
            this.usuario.UsuarioId = null; 
            this.usuario.Login = null; 
        },
        VerificaQueElUsuarioEsteIngresado: function () {
            let sinLogin = true;
            let sinNombreCompleto = true;

            if (this.login !== "" && this.login !== null) {
                sinLogin = false;
            }

            if (this.nombres !== "" && this.nombres !== null) {
                sinNombreCompleto = false;
            }

            if (this.primerApellido !== "" && this.primerApellido !== null) {
                sinNombreCompleto = false;
            }

            if (this.segundoApellido !== "" && this.segundoApellido !== null) {
                sinNombreCompleto = false;
            }

            if (sinLogin == true && sinNombreCompleto == true) {
                comun.mensajeDeAlerta("No se ha ingresado el login, nombre, primer o segundo apellido del usuario para poder hacer la busqueda.", null, null);
                return false
            }

            return true;
        },
        BuscarUsuarios: function() {
            this.LimpiaParaNuevaBusqueda();
            if(this.VerificaQueElUsuarioEsteIngresado()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    Login: this.login,
                    Nombres: this.nombres,
                    PrimerApellido: this.primerApellido,
                    SegundoApellido: this.segundoApellido,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.ajustesDeUsuarios.ObtenUsuarios,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        this.respuestaDeListadoDeUsuarios = respuesta.data.Usuarios;
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        }, 
        ModificaElEstatusDelUsuario(activo, usuarioId) {
            comun.SeEstaCargandoInformacion(true);

            const parametros = {
                    UsuarioId: usuarioId,
                    Activo: activo,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.ajustesDeUsuarios.ModificaElEstatusDelUsuario,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        this.BuscarUsuarios();
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
        },
        AsignaElUsuarioYLogin: function(usuarioId, login) {
            this.usuario.UsuarioId = usuarioId
            this.usuario.Login = login
        }, 
        CancelaLaEdicionDelUsuario () {
            this.LimpiaParaNuevoUsuario();
        }, 
        VerificaQueElUsuarioExista(usuario) {
            if (usuario == null || usuario == undefined || usuario.IdUsuario < 0){
                comun.mensajeDeAlerta("No existe un usuario para guardar.<br /><br />Recargue la página y si sigue sucediendo lo mismo, contacte el departamento de Informática.", null, null);
                return false
            }

            return true
        },
        GuardaElUsuario(usuario) {
            if (this.VerificaQueElUsuarioExista(usuario)) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    Usuario: usuario,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.ajustesDeUsuarios.ActualizaLaInformacionDelUsuario,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        }
    }
}
</script>

<style scoped>
   .table-header-global{
      background-color: #004746;
    }

    .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
        border: 1px solid rgb(44, 44, 44);
    }

    .text-form {
        color: black;
    }

    .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
        border: 1px solid #656161 !important;         
    }

    .bottom-style{
      background-color: #004746;
      color: white;
      border: 1px solid rgb(44, 44, 44);
      border-radius: 0px 0px 0px 0px;
    }
    .card-header {
        background-color: #007573;
        border: 1px solid rgb(44, 44, 44);

    }
    .subtitle-text{
        color: #7e7f74;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICUS/Usuarios/AjustesDeUsuarios/Index.vue